import store from '@/store';
import AccountingDashboard from '@/modules/accounting/views/Dashboard';
import Invoices from '@/modules/accounting/views/Invoices';
import OverdueInvoices from '@/modules/accounting/views/OverdueInvoices';
import PaidInvoices from '@/modules/accounting/views/PaidInvoices';
import Invoice from '@/modules/accounting/views/invoices/Invoice';
import InvoiceTemplateDesigner from '@/modules/accounting/views/InvoiceTemplateDesigner';
import ReceivePayments from '../views/ReceivePayments';
// Deposits and CC Processing
import ChequeDeposits from '../views/deposits/ChequeDeposits'
import DepositDetail from '../views/deposits/depositDetail/Deposit'
import DepositPrintout from '../views/deposits/DepositPrintout'
import CreditCardProcessing from '../views/deposits/CreditCardProcessing'
import CreditCardBatch from '../views/deposits/creditCardBatch/Batch'
// Reports
import UnpaidInvoices from '../views/reports/UnpaidInvoices'
import UnsentInvoices from '../views/reports/UnsentInvoices'
import ArchivedInvoices from '../views/reports/ArchivedInvoices'
import UncollectibleInvoices from '../views/reports/UncollectibleInvoices'
// Statements
import Statements from '../views/statements/Statements';
import Statement from '../views/statements/Statement';
// Reconciliations
import Reconciliations from '../views/reconciliations/Reconciliations';
import Reconciliation from '../views/reconciliations/Reconciliation';
// Expenses
import PostExpenses from '../views/expenses/PostExpenses'
import ExpenseBase from '../components/expense/ExpenseBase'
import ExpenseOverview from '../views/expenses/expenseDetail/ExpenseOverview'
import BudgetStatus from '../views/reports/BudgetStatus'
import Accounts from '../views/accounts/Accounts';

const routes = [
  {
    path: '/accounting/',
    component: () => import('@/modules/accounting/components/ModuleBase'),
    meta: { appKey: 'accounting' },
    children: [
      {
        path: 'dashboard',
        name: 'AccountingDashboard',
        component: AccountingDashboard,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'accounts',
        name: 'Accounts',
        component: Accounts
      },

      // Credit Cards
      {
        path: 'credit-cards',
        name: 'CreditCardProcessing',
        component: CreditCardProcessing
      },
      {
        path: 'credit-card-batch/:id',
        name: 'CreditCardBatch',
        component: CreditCardBatch
      },

      // Deposits
      {
        path: 'deposits',
        name: 'ChequeDeposits',
        component: ChequeDeposits,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'deposit-detail/:id',
        name: 'DepositDetail',
        component: DepositDetail
      },

      // Receive Payments
      {
        path: 'receive-payments',
        name: 'ReceivePayments',
        component: ReceivePayments
      },
      
      // Legacy Statements
      {
        path: 'statements',
        name: 'AllStatements',
        component: Statements,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'statement-detail/:id',
        name: 'StatementDetail',
        component: Statement
      },



      // --- Reconciliations
      {
        path: 'reconciliations',
        name: 'AllReconciliations',
        component: Reconciliations,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'reconciliation-detail/:id',
        name: 'ReconciliationDetail',
        component: Reconciliation
      },


      // Expenses
      {
        path: 'expenses',
        name: 'PostExpenses',
        component: PostExpenses,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'expense-detail/:id/',
        component: ExpenseBase,
        children: [
          {
            path: 'overview',
            name: 'ExpenseOverview',
            component: ExpenseOverview
          }
        ]
      },

      {
        path: 'invoices/',
        name: 'Invoices',
        component: Invoices,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'overdue-invoices/',
        name: 'OverdueInvoices',
        component: OverdueInvoices,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'paid-invoices/',
        name: 'PaidInvoices',
        component: PaidInvoices,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'budget-status/',
        name: 'BudgetStatus',
        component: BudgetStatus,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'invoice-detail/:id/overview',
        name: 'InvoiceOverview',
        component: Invoice

      },
      {
        path: 'invoice-template-designer',
        name: 'InvoiceTemplateDesigner',
        component: InvoiceTemplateDesigner,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      }
    ],
  },
  {
    path: '/reports/',
    component: () => import('../views/reports/ReportsBase'),
    beforeEnter: (to, from, next) => {
      store.dispatch('clearSubnav')
      next()
    },
    children: [
      {
        path: 'unpaid-invoices',
        name: 'UnpaidInvoicesReport',
        component: UnpaidInvoices
      },
      {
        path: 'unsent-invoices',
        name: 'UnsentInvoicesReport',
        component: UnsentInvoices
      },
      {
        path: 'archived',
        name: 'ArchivedInvoicesReport',
        component: ArchivedInvoices
      },
      {
        path: 'uncollectible',
        name: 'UncollectibleInvoicesReport',
        component: UncollectibleInvoices
      }
    ]
  },
  {
    path: '/deposit-printout/:id',
    name: 'DepositPrintout',
    component: DepositPrintout,
    meta: { forPrinting: true }
  }
]

export default routes
